export enum FieldState {
  HIDDEN = 'HIDDEN',
  DISPLAY = 'DISPLAY',
  MANDATORY = 'MANDATORY',
}
